import * as defaults from "./constants/defaults";
import { environment } from "./build_environment";

// -----------------------
//       next-dev DEV
// -----------------------

//DEFAULT
const config_dev = {
  userPoolId: "us-east-1_kxIr7xkzN",
  region: "us-east-1",
  userPoolWebClientId: "5ucpl1udve2kfnbf1a70ihfhvl",
};

const config_dev_new = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_kxIr7xkzN",
  aws_user_pools_web_client_id: "5ucpl1udve2kfnbf1a70ihfhvl",
}

// -----------------------
//       next-dev PROD
// -----------------------

const config_prod = {
  userPoolId: 'us-east-1_y98DN8Ny1',
  region: 'us-east-1',
  userPoolWebClientId: '20voquk5vfn54okk3rf0ucqncj',
};
const config_prod_new = {
  aws_user_pools_id: 'us-east-1_y98DN8Ny1',
  aws_project_region: 'us-east-1',
  aws_user_pools_web_client_id: '20voquk5vfn54okk3rf0ucqncj',
  aws_cognito_region: "us-east-1",
};
export const RUNNING_ENVIRONMENT = environment;

/* tslint:disable */
const config =
  String(environment) === String(defaults.DEV) ? config_dev_new : config_prod_new;
/* tslint:enable */

export default config;
